import Client from "@/repositories/Client/AxiosClient.js"

const resource = `/api/mini-grids`

export default {
  list() {
    return Client.get(`${resource}`)
  },
  create(miniGridPM) {
    return Client.post(`${resource}`, miniGridPM)
  },
  update(miniGridId, miniGrid) {
    return Client.put(`${resource}/${miniGridId}`, miniGrid)
  },
  delete(miniGridId) {
    return Client.delete(`${resource}/${miniGridId}`)
  },
  get(miniGridId) {
    return Client.get(`${resource}/${miniGridId}`)
  },
  geoData(miniGridId) {
    return Client.get(`${resource}/${miniGridId}?relation=1`)
  },
  transactions(miniGridId, period) {
    return Client.post(`${resource}/${miniGridId}/transactions`, period)
  },
  soldEnergy(miniGridId, period) {
    return Client.post(`${resource}/${miniGridId}/energy`, period)
  },
}
